import { FC } from "react";
import { ToggleButton, ToggleButtonProps } from "./ToggleButton";

export type ItemToggleButtonProps = {

} & Omit<ToggleButtonProps, 'width' | 'height'>;

export const ItemToggleButton: FC<ItemToggleButtonProps> = ({ ...rest }) => {
    return (<ToggleButton width={66} height={48} {...rest} />);
}